'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSenderType = undefined;

var _curry = require('transmute/curry');

var _curry2 = _interopRequireDefault(_curry);

var _commonMessageFormatGetters = require('../../common-message-format/operators/commonMessageFormatGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isSenderType = exports.isSenderType = (0, _curry2.default)(function (senderType, message) {
  return (0, _commonMessageFormatGetters.getSenderType)(message) === senderType;
});